import faqs from '@/store/modules/faqs/faqs'
import createFaq from '@/store/modules/faqs/faq-create'
import editFaq from '@/store/modules/faqs/faq-edit'
import deleteFaq from '@/store/modules/faqs/faq-delete'

export default {
    faqs,
    createFaq,
    editFaq,
    deleteFaq
}
